module.exports = __webpack_public_path__ + "img/free-150.1710f671.jpg";